let sidemenuTrigger = document.querySelector(".sidemenu--header");
let sidemenu = document.querySelector(".sidemenu--menu");
let orgSidemenuHeader;
if (sidemenuTrigger) {
    orgSidemenuHeader = sidemenuTrigger.querySelector('span').innerText;
}

window.addEventListener('resize', function () {
    if (window.innerWidth < 992) {
        if (sidemenuTrigger) {
            sidemenuDropper(sidemenuTrigger);
        }
        if (sidemenu) {
            sidemenuHeader();
        }
    }
});
if (sidemenuTrigger) {
    window.addEventListener('resize', function () {
        sidemenuHeader();
        sidemenuDropper(sidemenuTrigger);
    });
}

if (sidemenuTrigger) {
    sidemenuHeader();
    sidemenuDropper(sidemenuTrigger);
}

function sidemenuHeader() {
    let sidemenuLinks = document.querySelector(".sidemenu--menu").querySelectorAll("li");
    for (var i = 0; i < sidemenuLinks.length; i++) {
        let sidemenuLinksLink = sidemenuLinks[i].querySelector('a');
        if (sidemenuLinksLink) {
            if (sidemenuLinksLink.classList.contains("active") && window.innerWidth < 992) {
                let activeText = sidemenuLinksLink.innerHTML;
                var decoded = decodeHtml(activeText);
                sidemenuLinksLink.style.display = "none";
                sidemenuTrigger.querySelector('span').innerText = decoded;
            } else if (window.innerWidth > 992) {
                sidemenuLinksLink.style.display = "block";
                sidemenuTrigger.querySelector('span').innerText = orgSidemenuHeader;
            }
        }
    }
}

function sidemenuDropper(item) {
    if (window.innerWidth < 992) {
        item.addEventListener('click', function () {
            var sidemenu = this.nextElementSibling;
            var arrow = this.querySelector(".dropdown-arrow");

            if (sidemenu.style.maxHeight) {
                sidemenu.style.maxHeight = null;
                arrow.style.transform = "rotate(-90deg)";

                setTimeout(() => {
                    sidemenu.style.overflow = "hidden";
                    sidemenu.style.paddingTop = null;
                }, 200);

            } else {
                if (document.querySelector('.filter.open')) {
                    document.querySelector('.filter.open').classList.remove("open");
                }
                arrow.style.transform = "rotate(0)";
                sidemenu.style.maxHeight = "500px";
                // sidemenu.style.overflow = "auto";
                sidemenu.style.paddingTop = "1rem";
            }
        });
    }
}

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}


// WEBPACK FOOTER //
// ./scripts/components/sidemenu.js